import RefferalsInfo from 'components/molecules/m-referals-info';
import RefferAndEarn from 'components/molecules/m-reffer-and-earn';
import renderIcon from 'icon';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const Refferals = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
        {renderIcon(IoArrowBackCircleSharp, {
          size: 24,
          className: 'text-black flex-shrink-0 cursor-pointer hover:text-gray-600 transition-colors',
          onClick: () => navigate('/account')
        })}
        <span
          className="font-semibold"
          style={{ color: '#222', cursor: 'pointer' }}
          onClick={() => navigate('/account')}>
          Account
        </span>
        <span>›</span>
        <span className="font-semibold" style={{ color: '#222' }}>
          Referrals
        </span>
      </div>
      <div>
        <h2 className="font-semibold text-lg mb-4">Refer a Friend</h2>
        <RefferalsInfo />
        <RefferAndEarn />
      </div>
    </>
  );
};

export default Refferals;
